import {ApigetLatelyDrawedPeriods} from '@api/service'
export default {
    namespaced: true,
    state: {
        lotteryIndex: 0,
        //往期开奖列表
        lotteryOpenList:[],
        //当前显示多少期
        periodsLimit:30,
        //当前选择的彩种code
        lotteryCode:'',
        //当前所选彩种的类别code
        lotteryTypeCode:'',
        //加载
        chartLoading:true,
        //防抖
        lotteryNumbTypeCode:'',
        //折线图是否显示
        lineChartShow:true,
        //遗漏统计
        missNumberShow:true,
        //连出 连中等等统计
        statisticalShow:true,
    },
    mutations: {
        setlotteryOpenList(state,payload){
            state.lotteryOpenList = payload
        },
        setlotteryIndex(state,payload){
            state.lotteryIndex = payload
        },
        setperiodsLimit(state,payload){
            state.periodsLimit = payload
        },
        setlotteryCode(state,payload){
            state.lotteryCode = payload
        },
        setlotteryTypeCode(state,payload){
            state.lotteryTypeCode = payload
        },
        setchartLoading(state,payload){
            state.chartLoading = payload
        },
        setlotteryNumbTypeCode(state,payload){
            state.lotteryNumbTypeCode = payload
        },
        setLineChartShow(state,data){
            state.lineChartShow = data;
        },
        setMissNumberShow(state,data){
            state.missNumberShow = data;
        },
        setStatisticalShow(state,data){
            state.statisticalShow = data;
        },
    },
    actions:{
        getHisPeriodsPage({commit,state},lotteryCode){
            return new Promise(async(resolve,reject)=>{
                let res = await ApigetLatelyDrawedPeriods({
                    limit:100,
                    lotteryCode
                })
                if(res.code == '12200'){
                    commit('setlotteryOpenList',res.data.list)
                }
                resolve(res)
            })
        }
    },
    getters:{
        // 不反转的开奖数组
        lotteryTrendList(state) {
            let list = [...state.lotteryOpenList];
            if(list.length > state.periodsLimit) list.length = state.periodsLimit;
            let finalList = list.filter(li=>{
                return li.drawingNumber != undefined
            })
            return finalList
        },
        //将开奖数组反转
        lotteryReverseList(state){
            let list = [...state.lotteryOpenList];
            if(list.length > state.periodsLimit) list.length = state.periodsLimit;
            list = list.filter(li=>{
                return li.drawingNumber != undefined
            })
            return list.reverse();
        },
        openNumbArr(state,getters){
            let lotteryReverseList = getters.lotteryReverseList;
            //筛选开奖号码 用于万 千位折线图使用
            let len = lotteryReverseList.length;
            if(len == 0) return [];
    
            let list = [];
            let openArrLen = lotteryReverseList[0].drawingNumber.split(',').length;
            for(let i = 0; i < openArrLen ; i++){
                let openList = [];
                for(let k = 0 ; k < len ; k++){
                    openList.push(lotteryReverseList[k].drawingNumber.split(',')[i].replace(/^0/g,''));
                }
                list.push(openList);
            }
            return list
        },
        oneNumbArr:(state,getters) => (index = 0) => {
            if(getters.openNumbArr.length == 0) return [];
            return getters.openNumbArr[index]
        }
    }
}